import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, X } from "lucide-react";
import { useBrowserNotifications } from "@/hooks/use-browser-notifications";

export const NotificationPermissionPrompt = () => {
  const { permission, requestPermission, isSupported } = useBrowserNotifications();
  const [dismissed, setDismissed] = useState(false);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const hasSeenPrompt = localStorage.getItem("notification-prompt-seen");
    if (!hasSeenPrompt && permission === "default" && isSupported) {
      // Show after 5 seconds
      const timer = setTimeout(() => {
        setShown(true);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [permission, isSupported]);

  const handleEnable = async () => {
    await requestPermission();
    localStorage.setItem("notification-prompt-seen", "true");
    setDismissed(true);
  };

  const handleDismiss = () => {
    localStorage.setItem("notification-prompt-seen", "true");
    setDismissed(true);
  };

  if (!shown || dismissed || !isSupported || permission !== "default") {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm animate-in slide-in-from-bottom-5">
      <Card className="p-4 shadow-lg border-primary/20">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-full bg-primary/10">
            <Bell className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-sm mb-1">Enable Notifications</h4>
            <p className="text-xs text-muted-foreground mb-3">
              Get instant notifications for messages, invoices, projects, and more
            </p>
            <div className="flex gap-2">
              <Button size="sm" onClick={handleEnable} className="text-xs">
                Enable
              </Button>
              <Button size="sm" variant="ghost" onClick={handleDismiss} className="text-xs">
                Not now
              </Button>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 shrink-0"
            onClick={handleDismiss}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </Card>
    </div>
  );
};
